var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingsTooltipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.296875,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#7048E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.29688V6.29688H11.5V5.29688H12.5V6.29688H14.5C14.7761 6.29688 15 6.52074 15 6.79688V14.7969C15 15.073 14.7761 15.2969 14.5 15.2969H5.5C5.22386 15.2969 5 15.073 5 14.7969V6.79688C5 6.52074 5.22386 6.29688 5.5 6.29688H7.5V5.29688H8.5ZM14 10.2969H6V14.2969H14V10.2969ZM9.5 11.2969V13.2969H7V11.2969H9.5ZM7.5 7.29688H6V9.29688H14V7.29688H12.5V8.29688H11.5V7.29688H8.5V8.29688H7.5V7.29688Z",
    fill: "#7048E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingsTooltipIcon);
export default __webpack_public_path__ + "static/media/Meetings-Tooltip-Icon.eb88ccd34e6da511579e2ba10c29168e.svg";
export { ForwardRef as ReactComponent };